<script lang="ts">
  import { state, return_to_lobby } from './State'
  import TopBarPage from '../Navigation/TopLevelPages/TopBarPage.svelte'
  import ReviewGrid from '../Review/Grid.svelte'
  import CtaButton from '../Generic/CtaButton.svelte'
  import type { RetroAuthedUser } from '../Users/types'
  export let user: RetroAuthedUser
</script>

<TopBarPage>
  <div id="grid">
    <ReviewGrid />
  </div>
  {#if user.uid === $state.leader}
    <div id="fab">
      <CtaButton on:click={$return_to_lobby}>Return To Lobby</CtaButton>
    </div>
  {/if}
</TopBarPage>

<style>
  #fab {
    position: fixed;
    right: 4em;
    bottom: 4em;
  }
  #grid {
    overflow: auto;
    max-width: 100%;
    margin-bottom: 7em;
  }
</style>
